import React, { useEffect } from "react";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";

import { configureStore } from "@reduxjs/toolkit";
import reducer from "./reducer/reducer";

import { AppModal, Frame, Theme } from "./components/base";
import { init } from "./utils/initialize";

import "./App.css";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["UI", "modal", "mute", "sounds"],
};

const persistedReducer = persistReducer(persistConfig, reducer);

// The immutable state check doesn't like non-serializable types (components)
// The serializer check doesn't like Symbols in actions
export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

const persistor = persistStore(store);

const App = () => {
  useEffect(() => {
    init(store).run();
  });

  return (
    <Provider store={store}>
      <PersistGate loading={<></>} persistor={persistor}>
        <Theme>
          <Frame />
          <AppModal />
        </Theme>
      </PersistGate>
    </Provider>
  );
};

export default App;
